
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.22 4.953a.75.75 0 011.06 0l2.667 2.667a.75.75 0 11-1.06 1.06L9.75 6.544 7.614 8.68a.75.75 0 11-1.061-1.06L9.22 4.953z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.75 4.733a.75.75 0 01.75.75v8a.75.75 0 01-1.5 0v-8a.75.75 0 01.75-.75z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.563 3.563a8.75 8.75 0 1112.374 12.374A8.75 8.75 0 013.563 3.563zM9.75 2.5a7.25 7.25 0 100 14.5 7.25 7.25 0 000-14.5z","fill":"currentColor"}})])
          )
        }
      }
    